import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ModalController,
  ToastController
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { TemplateProvider } from 'src/app/providers/TemplateProvider';

@Component({
  selector: 'app-template-import',
  templateUrl: './template-import.component.html',
  styleUrls: ['./template-import.component.scss'],
  standalone: false
})
export class TemplateImportComponent implements OnInit {
  archivoCSV = new FormControl(null);
  archivoCSVFile: File = null;
  importar: boolean = false;
  resultadoImportacion: any = null;
  @Input() gym;
  @Input() template_id;
  @Input() id_tipo_wod;
  @Input() idGym;
  @Input() atletas_add;
  @Input() grupos_add;
  @Input() id_user;
  @Input() wodMulti;

  constructor(
    private toastController: ToastController,
    private translate: TranslateService,
    private modalController: ModalController,
    private templateProvider: TemplateProvider
  ) { }

  ngOnInit() { }


  async importarDatosCSV() {
    if (this.archivoCSVFile) {
      this.resultadoImportacion = this.templateProvider.importarCSVTraining(
        this.idGym,
        this.archivoCSVFile,
        [],//this.id_user
        this.grupos_add,
        this.id_tipo_wod,
        this.id_user,
        this.wodMulti
      ).then((data) => {
        if (!data.error) {
          this.resultadoImportacion = data.data;
          //this.getUsers(1);            
        }
      });
    }
  }

  /**
* @author Sergio Castro
* @description Cancela la operación de importación de usuarios por medio de un archivo csv
* @date 23 septiembre 2020
*/
  cancelarImportacion() {
    this.archivoCSVFile = null;
    this.archivoCSV.setValue(null);
    // this.importar = false;
    this.resultadoImportacion = null;
  }

  /**
* @author Sergio Castro
* @description Lee el archivo csv para la importación de usuarios masiva
* @date 23 septiembre 2020
* @param event evento al accionar el input para elegir archivo csv
*/
  async readFile(event: any) {    
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].name.substring(event.target.files[0].name.length - 4) == '.csv') {
        this.archivoCSVFile = event.target.files[0];
      } else {
        let toast = await this.toastController.create({
          message: this.translate.instant('USERS.ONLY_CSV_TYPE_DOCUMENTS_ARE_ALLOWED'),
          position: 'bottom',
          duration: 3000,
        });
        toast.present();
        this.archivoCSVFile = null;
        this.archivoCSV.setValue(null);
      }
    }
  }

  cerrar() {
    this.modalController.dismiss();
  }

}
